<ng-container *transloco="let convert;">
  @if (showSuccess) {
    <success-message
      data-test-id="auto-check-success-message"
      [id]="'autocheck-success-message'"
      [message]="convert('profileManagement.autoCheck.textAutoCheckUserId')"
      [closeButton]=true
      (canceled)="removeSuccessMessage()"
    ></success-message>
  }
  <div class="autoCheck" data-test-id="auto-check-container">
    <div class="col-md-8">
      <h2 data-test-id="auto-check-header" tabindex="-1" class="focus-outline-none">{{convert('profileManagement.autoCheck.header')}}</h2>
      <p data-test-id="auto-check-description">{{convert('profileManagement.autoCheck.label1')}}
        <a data-test-id="auto-check-url-link" class="auto-check-url" tabindex="0" (click)="openAutoCheckUrlNewTab()" (keydown.enter)="openAutoCheckUrlNewTab()">{{convert('profileManagement.autoCheck.autoCheckUrl')}}</a>
        {{convert('profileManagement.autoCheck.label2')}}
      </p>
      <p data-test-id="auto-check-description-2"> {{convert('profileManagement.autoCheck.label3')}}
      </p>
    </div>
    <div class="col-md-4">
      <img data-test-id="auto-check-logo" class="autoCheck__image" alt="{{convert('profileManagement.autoCheck.altAutoCheckLogo')}}" src="../../../ui/assets/img/auto-check-logo.png">
    </div>
  </div>

  <div class="col-md-12 p-0 autocheck-user-id-background" data-test-id="auto-check-user-id-section">
    <div class="user-id-header pt-3 ps-3" data-test-id="auto-check-user-id-header">{{convert('profileManagement.autoCheck.userIdHeader')}}</div>
    <div>
      <ng-container *ngTemplateOutlet="addAutoCheckUserIdLayout"></ng-container>
      <ng-container *ngTemplateOutlet="autoCheckUserIdExistsLayout"></ng-container>
    </div>
  </div>

  <ng-template #addAutoCheckUserIdLayout>
    @if (!isUserIdAvailable) {
      <button
        data-test-id="auto-check-add-btn"
        data-track-elem="button"
        data-track-name="Add"
        class="btn btn-link pt-3 ps-3 add-btn position-relative"
        (click)="addUserId()"
        [attr.aria-label]="convert('profileManagement.autoCheck.ariaLabelAddAutoCheck')"
        tabindex="0"
        >
        {{convert('profileManagement.autoCheck.addBtn')}}
        <ng-container *ngTemplateOutlet="addTriangle"></ng-container>
      </button>
      <ng-container *ngTemplateOutlet="personalInfoDrawer"></ng-container>
    }
  </ng-template>


  <ng-template #autoCheckUserIdExistsLayout>
    @if (isUserIdAvailable) {
      <div class="info-content" data-test-id="auto-check-user-id-value">{{ autoCheckUserId }}</div>
      <div class="content-button">
        <button
          data-test-id="auto-check-edit-btn"
          data-track-elem="button"
          data-track-name="Edit"
          class="btn btn-link add-btn position-relative vertical-align"
          (click)="onEditAutoCheckUserId()"
          aria-label="convert('profileManagement.autoCheck.ariaLabelEditAutoCheck')"
          tabindex="0"
          >
          {{convert('profileManagement.autoCheck.editBtn')}}
          <ng-container *ngTemplateOutlet="addTriangle"></ng-container>
        </button>
        <strong> | </strong>
        <button
          data-test-id="auto-check-remove-btn"
          data-track-elem="button"
          data-track-name="Remove"
          class="btn btn-link add-btn position-relative vertical-align"
          (click)="onRemoveUserId(null)"
          [attr.aria-label]="convert('profileManagement.autoCheck.ariaLabelAddAutoCheck')"
          tabindex="0"
          >
          {{convert('profileManagement.autoCheck.removeBtn')}}
        </button>
      </div>
      <ng-container *ngTemplateOutlet="personalInfoDrawer"></ng-container>
    }
  </ng-template>

  <ng-template #personalInfoDrawer>
    <section data-test-id="auto-check-drawer" class="ui-drawer" [ngClass]="{ 'is-open': openDrawer}">
      <button
        data-test-id="auto-check-drawer-close-btn"
        data-track-elem="icon"
        data-track-name="Close"
        data-track-trigger="close"
        class="drawer__close"
        [attr.aria-label]="convert('common.btnClose')"
        tabindex="0"
        (click)="closeDrawer()">
        <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
      </button>

      @if (addingAutoCheckUserId) {
        <ng-container *ngTemplateOutlet="AutoCheckUserIdForm"></ng-container>
      }
    </section>
  </ng-template>

  <ng-template #addTriangle>
    @if (isDrawerOpen) {
      <ng-container *ngTemplateOutlet="tmplDrawerIndicator"></ng-container>
    }
  </ng-template>

  <ng-template #tmplDrawerIndicator>
    <div class="arrow-up"></div>
    <div class="arrow-border"></div>
  </ng-template>

  <ng-template #AutoCheckUserIdForm>
    <form data-test-id="auto-check-user-id-form" class="form" [formGroup]="userIdFormGroup" (ngSubmit)="saveUserId()">
      <label class="info-label" for="userId">{{!isUserIdAvailable ? convert('profileManagement.autoCheck.textAddUserId') : convert('profileManagement.autoCheck.textEditUserId')}}</label>
      <div class="input-wrapper">
        <span class="input-label">{{convert('profileManagement.autoCheck.userIdHeader')}}</span>
        <input
          data-test-id="auto-check-user-id-input"
          class="input form-control"
          type="text"
          id="userId"
          formControlName="userId"
          required
          userId
          aria-required="true"
          />

      </div>
    </form>

    <div class="action-btns">
      <button
        data-test-id="auto-check-save-btn"
        data-track-elem="button"
        data-track-name="Save"
        class="btn btn-primary bid-buttons me-2"
        (click)="saveUserId()"
        tabindex="0"
        >
        {{convert('profileManagement.autoCheck.saveBtn')}}
      </button>
      <button
        data-test-id="auto-check-cancel-btn"
        data-track-elem="button"
        data-track-name="Cancel"
        class="btn btn-link bid-buttons"
        (click)="closeDrawer()"
        tabindex="0"
        >
        {{convert('common.btnCancel')}}
      </button>
    </div>
  </ng-template>
  <app-remove-user-id-modal data-test-id="auto-check-remove-modal" (removed)="onRemoveUserId($event)"></app-remove-user-id-modal>
  <app-common-interstitial-modal
    data-test-id="auto-check-interstitial-modal"
    [modalId]="autoCheckConstant"
    [reportProvider]="autoCheckConstant"
    [inventoryItemUuid]="autoCheckConstant"
    [tenantFullName]="tenantFullName"
    [commonInterstitialModalTranslations]="commonInterstitialModalTranslations"
    (continue)="continueToAutoCheckUrlNewTab($event)">
  </app-common-interstitial-modal>
</ng-container>
